import React from "react";
import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import ATMPagination from "src/components/UI/atoms/ATMPagination/ATMPagination";
import ATMTable, {
    columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";
import { isCheckActionsPermission } from "src/helpers/userAccessFun";
import { UserModuleActionTypes, UserModuleNameTypes } from "src/models/userAccess/UserAccess.model";
type Props = {
    columns: columnTypes[];
    rows: any[];
    onAddNew: () => void;
    getActionOptions: any;
    paginationProps: {
        isTableLoading: boolean;
        totalItems: number;
        page: number;
        rowsPerPage: number;
        searchValue: string;
        setPage: (newPage: number) => void;
        setRowsPerPage: (newLimit: number) => void;
        setSearchValue: (newValue: string) => void;
    };
};

const GoalCategoriesListing = ({
    columns,
    rows,
    onAddNew,
    paginationProps: {
        totalItems,
        isTableLoading,
        page,
        rowsPerPage,
        searchValue,
        setPage,
        setRowsPerPage,
        setSearchValue,
    },
}: Props) => {
    return (
            <div className="flex flex-col p-4">
                {/* Page Header */}
                <div className="p-4">
                    <ATMPageHeader
                        pageTitle="Goal Categories"
                        searchValue={searchValue}
                        onSearchChange={setSearchValue}
                        buttonProps={{
                            btnName: "Add New",
                            onClick: onAddNew,
                        }}
                        hideAddButton={
                            !isCheckActionsPermission({
                                moduleName: UserModuleNameTypes.GOAL_CATEGORY,
                                actionName: UserModuleActionTypes.ADD,
                            })
                        }
                    />
                </div>

                {/* Table */}
                <div className="flex flex-col flex-1 overflow-auto">
                    <ATMTable
                        columns={columns}
                        rows={rows}
                        rowExtraClasses={() => "min-h-[40px]"}
                        isLoading={isTableLoading}
                    />
                </div>

                <div className="flex justify-end p-4 py-2">
                    <ATMPagination
                        page={page}
                        rowsPerPage={rowsPerPage}
                        onPageChange={setPage}
                        onRowsPerPageChange={setRowsPerPage}
                        rowCount={totalItems}
                        rows={rows}
                    />
                </div>
            </div>
    );
};

export default GoalCategoriesListing;
